import { render, staticRenderFns } from "./RAPSComaScore.vue?vue&type=template&id=249b01a9&scoped=true"
import script from "./RAPSComaScore.vue?vue&type=script&lang=js"
export * from "./RAPSComaScore.vue?vue&type=script&lang=js"
import style0 from "./RAPSComaScore.vue?vue&type=style&index=0&id=249b01a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249b01a9",
  null
  
)

export default component.exports